document.addEventListener("DOMContentLoaded", () => {
	const mediaLinksMeta = document.querySelectorAll(
		".media-links-item-meta"
	);

	mediaLinksMeta.forEach((item) => {
		if (item.clientHeight > 40) {
			item.classList.add("multiple-lines");
		}
	});
});